import { engineComponent, Logger } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../Utils/FrameTimer";
import { Symbols } from "../Symbols";
import { Machine } from "../Machine";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { StageController } from "../../Components/StageController";
import { WinAnimator } from "../WinAnimator";
import { BonusController } from "./BonusController";
import { GameManager } from "../../Managers/GameManager";
import { PlayList } from "../../Components/Sounds/PlayList";
import { HtmlController } from "../../HTMLComponents/HtmlController";
import { AmbientBackground } from "../../Utils/AmbientBackground";
import { WinAnimatorBonus } from "../../CustomComponents/WinAnimatorBonus";
import { MachineBonus } from "../../CustomComponents/MachineBonus";
import { CustomUtils } from "../../Utils/CustomUtils";
import { BaseView } from "../Base/BaseView";
import { SceneHolderElement } from "../../CustomComponents/SceneHolderElement";
import { LayoutContainerElement } from "../../CustomComponents/LayoutContainerElement";

@engineComponent(ComponentTypes.DisplayObject)
export class BonusView extends LayoutContainerElement {
    private _controller: BonusController;
    private _introDelay: FrameTimerEventEmitter;
    private _outroDelay: FrameTimerEventEmitter;

    private _symbols: Symbols;
    private _machine: MachineBonus;
    private _winAnimator: WinAnimatorBonus;
    private _bonusMessageStart: HTMLElement;
    private _respinCounter: number = 0;
    private _transition: SwitchElement;
    private _transitionSceneHolder: SceneHolderElement;
    private _background: SwitchElement;

    constructor() {
        super();

        this._introDelay = CreateFrameTimer("introDelay");
        this._introDelay.on(FrameTimerEvents.Complete, this.introFinished.bind(this));

        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));

        StageController.bonusStageContainer = this;
    }

    create(node: Element): void {
        super.create(node);

        if (this.childs != null) {
            for (let key in this.childs) {
                if (this.childs[key] instanceof Symbols) {
                    this._symbols = this.childs[key];
                    this.removeChild(this._symbols);
                }

                if (this.childs[key] instanceof Machine) {
                    this._machine = this.childs[key];
                }

                if (this.childs[key] instanceof WinAnimatorBonus) {
                    this._winAnimator = this.childs[key];
                }

                if (key === "BonusTransition" && this.childs[key] instanceof SwitchElement) {
                    this._transition = this.childs[key];
                    this._transitionSceneHolder = <SceneHolderElement>this._transition.getChildElementByName("Scene");
                }
            }

            this._bonusMessageStart = document.getElementById("bonusMessageStart");

            if (this.childs["Background"] != null) {
                this._background = this.childs["Background"];
            }

            if (DEBUG) {
                if (this._symbols == null) {
                    this.log("ERROR no symbols");
                }

                if (this._machine == null) {
                    this.log("ERROR no machine");
                }

                if (this._winAnimator == null) {
                    this.log("WARNING no winAnimator");
                }

                if (this._bonusMessageStart == null) {
                    this.log("ERROR no bonusMessageStart");
                }
            }
        }

        this.setupTransitionSceneElement();
    }

    disableLogo(): void {
        // if (this.childs['Logo'] != null) {
        //     this.removeChild(this.childs['Logo']);
        // }
    }

    initReceived(controller: BonusController): void {
        if (DEBUG) {
            this.log("initReceived");
        }

        this._controller = controller;

        if (this._symbols != null) {
            if (this._machine != null) {
                if (GameManager.bonusRespinsResponse != null) {
                    if (
                        GameManager.bonusRespinsResponse.initData != null &&
                        GameManager.bonusRespinsResponse.initData.reels !== null
                    ) {
                        if (
                            GameManager.bonusRespinsResponse.initData.customData &&
                            GameManager.bonusRespinsResponse.initData.customData["symbolValues"]
                        ) {
                            let bonusReels: Array<Array<number>> =
                                GameManager.bonusRespinsResponse.initData.customData["symbolValues"];

                            this._machine.on(Machine.ReelStopped, this.onReelStopped.bind(this));
                            this._machine.on(Machine.MachineStopped, this.machineStopped.bind(this));
                            this._machine.initialize(
                                this._symbols,
                                GameManager.bonusRespinsResponse.initData.reels,
                                bonusReels,
                                this.childs["BonusTeasing"],
                                null,
                                null,
                                this._winAnimator,
                            );
                        }
                    }

                    if (this._winAnimator != null) {
                        this._winAnimator.on(WinAnimator.FinishWinCalculation, this.finishWinCalculation.bind(this));
                        this._winAnimator.on(WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
                        this._winAnimator.on(
                            WinAnimatorBonus.WinAnimatorPrepared,
                            this.winAnimatorScenePrepared.bind(this),
                        );
                        this._winAnimator.on(
                            WinAnimatorBonus.TotalWinCountFinished,
                            this.totalWinCountFinished.bind(this),
                        );
                        this._winAnimator.on(
                            WinAnimatorBonus.WinAnimatorTotalStart,
                            this.winAnimatorTotalStart.bind(this),
                        );
                        this._winAnimator.initialize(
                            this._symbols,
                            null,
                            this.childs["BonusNoWinContainer"],
                            this.childs["BonusWinContainer"],
                            this.childs["BonusStickyContainer"],
                            this.childs["BonusCountingBlast"],
                            this._background,
                        );
                        this._winAnimator.initializeMultiplierContainer(
                            this.childs["BigMultiplier"],
                            this.childs["TopMultipliers"],
                        );
                    }
                } else {
                    if (DEBUG) {
                        this.log("ERROR no bonus reponse");
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no symbols");
            }
        }

        this.visible = false;
    }

    initIntro(): void {
        StageController.baseStage = false;
        StageController.bonusStage = true;

        this.visible = true;

        AmbientBackground.changeAmbientBackground("bonus", 0);

        if (BaseView.BonusCounters != null && this.childs["BonusTopCounters"] != null) {
            this.childs["BonusTopCounters"].addChild(BaseView.BonusCounters);
            BaseView.BonusCounters.goToCase("BONUS");
        }

        this._winAnimator.initIntroSameSymbolsOnReel(GameManager.bonusRespinsResponse.screen.reels);

        this._machine.setStoppedSymbolsArray(GameManager.bonusRespinsResponse.screen.reels);
        this._winAnimator.showInitSymbols(GameManager.bonusRespinsResponse.screen.reels);
        this._winAnimator.showInitWins(
            GameManager.bonusRespinsResponse.wins,
            GameManager.bonusRespinsResponse.currentWin,
        );
        this._winAnimator.setRemainingCountToGrand(
            GameManager.bonusRespinsResponse.bonusRespins.customData["countOfBonusSymbols"],
        );
        this._winAnimator.activateMultiplier(GameManager.bonusRespinsResponse.gameMultiplier);

        if (CustomUtils.isLastBonusSpin()) {
            PlayList.loop("SND_BonusWait");
        } else {
            PlayList.loop("SND_BonusLoop");
            this._winAnimator.openVaults(true);
        }
    }

    spin(): void {
        StageController.baseStage = false;
        StageController.bonusStage = true;

        this._respinCounter = 0;

        PlayList.loop("SND_BonusLoop");

        if (
            this._bonusMessageStart != null &&
            !this._bonusMessageStart.classList.contains(HtmlController.DisabledClass)
        ) {
            this._bonusMessageStart.classList.add(HtmlController.DisabledClass);
        }

        this._machine.spinStart(this._winAnimator.reset(true), true, this._winAnimator.currentSymbols);
    }

    respin(spinBitmask: number): void {
        this._respinCounter++;

        if (
            this._bonusMessageStart != null &&
            !this._bonusMessageStart.classList.contains(HtmlController.DisabledClass)
        ) {
            this._bonusMessageStart.classList.add(HtmlController.DisabledClass);
        }

        this._machine.spinStart(this._winAnimator.reset(true), true, this._winAnimator.currentSymbols, spinBitmask);
    }

    stop(): void {
        if (this._winAnimator.interruptAnimation()) {
            this._machine.spinStop(null, true);
        }
    }

    startReceived(): void {
        if (
            this._bonusMessageStart != null &&
            !this._bonusMessageStart.classList.contains(HtmlController.DisabledClass)
        ) {
            this._bonusMessageStart.classList.add(HtmlController.DisabledClass);
        }

        this._machine.setStoppedSymbolsArray(GameManager.bonusRespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.bonusRespinsResponse.screen.reels);
    }

    spinReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.bonusRespinsResponse.screen.reels);
        this._machine.spinStop(null, false, true);
    }

    endReceived(): void {}

    onReelStopped(): void {
        this._winAnimator.onReelStopped(GameManager.bonusRespinsResponse.screen.reels, this._machine.actualReelStopped);
    }

    machineStopped(): void {
        /*        if (this._winAnimator.checkStickyBonusSymbols()) {
            this._controller.machineStoppedWithAnimation();

            return;
        }*/

        this._winAnimator.openVaults();

        this.winAnimatorScenePrepared();
    }

    /* Wait for expand wild animation if exists */
    private winAnimatorScenePrepared(): void {
        this._controller.machineStopped();

        if (
            this._winAnimator.showWins(
                GameManager.bonusRespinsResponse.wins,
                GameManager.bonusRespinsResponse.currentWin,
                this._transition,
            )
        ) {
            PlayList.stop("SND_BonusLoop", 30);
        }
    }

    private totalWinCountFinished(): void {
        if (this._transition != null) {
            this._transition.goToCase("FROM_TOTAL_COUNT");
        }
    }

    finishWinCalculation(): void {
        this._controller.winCalculationFinished();
    }

    finishWinAnimator(): void {
        this._controller.allWinsFinished();
        PlayList.loop("SND_BonusWait", 30);
    }

    winAnimatorTotalStart(): void {
        this._controller.winAnimatorTotalStart();
    }

    intro(long: boolean = false, previousModule: string): void {
        StageController.baseStage = false;
        StageController.bonusStage = true;

        this.visible = true;

        this._transition.goToCase("BONUS_INTRO");

        if (BaseView.BonusCounters != null && this.childs["BonusTopCounters"] != null) {
            this.childs["BonusTopCounters"].addChild(BaseView.BonusCounters);
            BaseView.BonusCounters.goToCase("BONUS");

            if (this._winAnimator != null) {
                this._winAnimator.setRemainingCountToGrand(
                    GameManager.bonusRespinsResponse.bonusRespins.customData["countOfBonusSymbols"],
                );
                for (let i = 0; i < GameManager.bonusRespinsResponse.screen.reels.length; i++) {
                    if (GameManager.bonusRespinsResponse.screen.reels[i].overlay != null) {
                        this._winAnimator.updateActiveBonusCounters(
                            GameManager.bonusRespinsResponse.screen.reels[i].overlay,
                        );
                    }
                }
            }
        }

        this._winAnimator.resetMultiplierContainer();
        this._winAnimator.openVaults();

        this._introDelay.start(30);
    }

    introFinished(): void {
        PlayList.loop("SND_BonusLoop");

        this._controller.introFinished();
    }

    outro(): void {
        StageController.bonusStage = true;
        this.visible = true;

        PlayList.stop("SND_BonusLoop");
        PlayList.stop("SND_BonusWait");
        this.outroToBase();
    }

    private outroToBase(): void {
        this._winAnimator.resetAnimations();

        if (this._transition != null) {
            this._transition.goToCase("BONUS_OUTRO");
        }
        PlayList.play("SND_BonusTransition");

        this._outroDelay.start(90);
    }

    outroFinished(): void {
        StageController.bonusStage = false;

        this.visible = false;
        BaseView.BonusCounters.goToCase("NORMAL");

        AmbientBackground.changeAmbientBackground("base", 180, 60);

        if (this._transition != null) {
            this._transition.goToCase("RESET");
        }

        if (this.childs["TopMultipliers"]) {
            (<SwitchElement>this.childs["TopMultipliers"]).goToCase("FADEOUT");
        }

        this._winAnimator.reset(true);
        this._controller.outroFinished();
    }

    enable(): void {
        PlayList.setVolume("SND_BaseLoop", 0);
        PlayList.stop("SND_BaseRespinLoop");
        PlayList.stop("SND_BaseRecapLoop");

        PlayList.play("SND_BonusMessage");
        PlayList.loop("SND_BonusWait");

        if (
            this._bonusMessageStart != null &&
            this._bonusMessageStart.classList.contains(HtmlController.DisabledClass)
        ) {
            this._bonusMessageStart.classList.remove(HtmlController.DisabledClass);
        }
    }

    private setupTransitionSceneElement(): void {
        this._transitionSceneHolder.addElement({
            element: this.childs["BonusReelsBg"],
            parent: this,
            index: this.getChildIndex(this.childs["BonusReelsBg"]),
        });
        this._transitionSceneHolder.addElement({
            element: this.childs["BonusTopCounters"],
            parent: this,
            index: this.getChildIndex(this.childs["BonusTopCounters"]),
        });
        this._transitionSceneHolder.addElement({
            element: this.childs["TopMultipliers"],
            parent: this,
            index: this.getChildIndex(this.childs["TopMultipliers"]),
        });
        this._transitionSceneHolder.addElement({
            element: this.childs["BonusNoWinContainer"],
            parent: this,
            index: this.getChildIndex(this.childs["BonusNoWinContainer"]),
        });
        this._transitionSceneHolder.addElement({
            element: this.childs["BonusWinContainer"],
            parent: this,
            index: this.getChildIndex(this.childs["BonusWinContainer"]),
        });
        this._transitionSceneHolder.addElement({
            element: this.childs["BonusStickyContainer"],
            parent: this,
            index: this.getChildIndex(this.childs["BonusStickyContainer"]),
        });
        this._transitionSceneHolder.addElement({
            element: this.childs["BigMultiplier"],
            parent: this,
            index: this.getChildIndex(this.childs["BigMultiplier"]),
        });
        this._transitionSceneHolder.addElement({
            element: this.childs["BonusLogo"],
            parent: this,
            index: this.getChildIndex(this.childs["BonusLogo"]),
        });
        this._transitionSceneHolder.addElement({
            element: this.childs["BonusWinAnimator"],
            parent: this,
            index: this.getChildIndex(this.childs["BonusWinAnimator"]),
        });
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Bonus/BonusView.ts
 **/